module.exports = __webpack_public_path__ + "static/media/coronah.3aa830db.gif";